import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { oktaAuth } from '../../config/OktaConfig';
import { SizeService } from '../../services/SizeService';
import { Size } from '../../Types';

const sizeService: SizeService = new SizeService(oktaAuth);

export const findProductByCode = createAsyncThunk('findProductByCode', async (query: string) => {
  if (!query) {
    return [];
  }

  return await sizeService.getSizesByProductCode(query);
});

export const storeProductSize = createAsyncThunk('storeProductSize', async (size: any) => {
  return await sizeService.storeProductSize(size);
});

export const overviewSlice = createSlice({
  name: 'overview',
  initialState: {
    isLoadingOverview: true,
    isLoadingForm: false,
    searchTerm: '',
    sizes: [] as Size[],
    notification: null as any
  },
  reducers: {
    searchProductByCode: (state, action) => {
      state.searchTerm = action.payload;
    },
    toggleNotification: (state, action) => {
      state.notification = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findProductByCode.pending, (state) => {
      state.isLoadingOverview = true;
    })
    .addCase(findProductByCode.fulfilled, (state, action) => {
      state.isLoadingOverview = false;

      if (action.payload.data) {
        state.sizes = action.payload.data;
      }
    })
    .addCase(findProductByCode.rejected, (state, action) => {
      state.isLoadingOverview = false;
      state.sizes = [];
    });   
    
    builder.addCase(storeProductSize.pending, (state) => {
      state.isLoadingForm = true;
    })
    .addCase(storeProductSize.fulfilled, (state, action) => {
      state.isLoadingForm = false;

      const size = state.sizes.find(size => {
        return size.productWeightsKey.size === action.payload.data.productWeightsKey.size;
      });

      if (size) {
        size.grossWeight = action.payload.data.grossWeight;
      } else {
        state.sizes.push(action.payload.data);
      }

      state.notification = {
        status: 'success',
        message: 'Product size stored successfully.',
      };
    })
    .addCase(storeProductSize.rejected, (state, action) => {
      state.isLoadingForm = false;

      state.notification = {
        status: 'error',
        message: 'Whoops, something went wrong while storing the product size.',
      };
    });   
  },
});

export const {
  searchProductByCode,
  toggleNotification
} = overviewSlice.actions;

export const selectSearchTerm = (state: any) => state.overview.searchTerm;
export const selectSizes = (state: any) => state.overview.sizes;
export const selectLoadingOverview = (state: any) => state.overview.isLoadingOverview;
export const selectLoadingForm = (state: any) => state.overview.isLoadingForm;
export const selectNotification = (state: any) => state.overview.notification;

export default overviewSlice.reducer;